(function($){

    // TODO: combine with generic slick slider code

    var $controller  = {

        debug: true,

        selector: '.wine-quotes',
        collection: null,

        init: function() {
            this.collection = $(this.selector);
            if(this.collection.length > 0) {
                this.listen();
            }
        },
        
        listen: function() {

            this.collection.slick({
                infinite: true,
                autoplay: !this.debug,
                arrows: true,
                dots: false,
                fade: true,
                pauseOnFocus: true,
                speed: 1000,
                prevArrow: '<a href="#" class="slick-prev"></a>',
                nextArrow: '<a href="#" class="slick-next"></a>'
            });

        }

    };

    $controller.init();

})(jQuery);


// WEBPACK FOOTER //
// ./tbo/js/widget/quote.js